import React, { Component, PropTypes } from 'react';
import Modal from 'common/components/Modal';
import shallowCompare from 'react-addons-shallow-compare';
import cx from 'classnames';
import { Message, Radio, Divider, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { getInsectsRef } from '../reducers/insectsRef';
import * as actions from '../actions/manips';

const mapStateToProps = state => ({
  insectsRef: getInsectsRef(state),
});

const initializeCaptures = (taskType, insectsRef) => {
  if (taskType !== 'INSECT') {
    return [];
  } else {
    return insectsRef.map(i => ({
      speciesId: i.id,
      label: i.label,
      value: 0,
    }));
  }
};

class CreateZone extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      isSpeciesThresholdDefault: true,
      otherSpeciesThresholdValue: null,
      speciesThreshold: [],
      canSubmit: false,
    };

    this._onNameChanged = this._onNameChanged.bind(this);
    this._onIsSpeciesThresholdDefaultChanged = this._onIsSpeciesThresholdDefaultChanged.bind(
      this
    );
    this._onSpeciesCaptureChanged = this._onSpeciesCaptureChanged.bind(this);
    this._onOtherSpeciesThresholdValueChanged = this._onOtherSpeciesThresholdValueChanged.bind(
      this
    );
    this._submit = this._submit.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.hasError) {
      this.setState({
        isLoading: false,
      });
    }
  }

  updatespeciesThreshold(existing, speciesId, value) {
    var index = existing.findIndex(
      obj => obj.speciesId === parseInt(speciesId, 0)
    );

    if (index >= 0 && parseInt(value, 0)) {
      existing[index].value = parseInt(value, 0);
    }
    return existing;
  }

  _onNameChanged(evt) {
    const { value } = evt.target;

    this.setState({
      name: value,
      canSubmit: value.length,
    });
  }

  _onIsSpeciesThresholdDefaultChanged(evt) {
    var speciesThreshold = initializeCaptures(
      this.props.taskType,
      this.props.insectsRef
    );

    this.setState(prevState => ({
      isSpeciesThresholdDefault: !prevState.isSpeciesThresholdDefault,
      speciesThreshold: !prevState.isSpeciesThresholdDefault
        ? []
        : speciesThreshold,
      otherSpeciesThresholdValue: !prevState.isSpeciesThresholdDefault
        ? null
        : 0,
    }));
  }

  _onOtherSpeciesThresholdValueChanged(evt) {
    const { value } = evt.target;

    this.setState(prevState => ({
      otherSpeciesThresholdValue: parseInt(value, 0),
    }));
  }

  _onSpeciesCaptureChanged(evt) {
    const { value, id } = evt.target;

    this.setState(prevState => ({
      speciesThreshold: this.updatespeciesThreshold(
        prevState.speciesThreshold,
        id,
        value
      ),
    }));
  }

  _submit(evt) {
    evt.preventDefault();

    const {
      name,
      speciesThreshold,
      isSpeciesThresholdDefault,
      otherSpeciesThresholdValue,
    } = this.state;
    if (name.length) {
      var data = {
        name: name,
        isSpeciesThresholdDefault: isSpeciesThresholdDefault,
        otherSpeciesThresholdValue: otherSpeciesThresholdValue,
        speciesThreshold: speciesThreshold,
      };
      this.props.onSubmit(data);

      this.setState({
        isLoading: true,
      });
    }
  }

  render() {
    const { onClose, hasError, taskType } = this.props;
    const {
      name,
      isSpeciesThresholdDefault,
      speciesThreshold,
      otherSpeciesThresholdValue,
      canSubmit,
      isLoading,
    } = this.state;

    const buttonClass = cx('ui primary button', {
      disabled: !canSubmit,
      loading: isLoading,
    });

    const radioLabel = this.state.isSpeciesThresholdDefault
      ? 'Paramètres par défaut activé'
      : 'Paramètres par défaut désactivé';

    return (
      <Modal isOpened closable onClose={onClose} scrolling>
        <div className="header">Ajouter un lieu</div>
        <div className="scrolling content">
          {hasError && (
            <Message color="red">Un lieu existe déjà avec ce nom</Message>
          )}
          <form id="zoneForm" className="ui form" onSubmit={this._submit}>
            <div className="ui field">
              <label>Nom</label>
              <input type="text" value={name} onChange={this._onNameChanged} />
            </div>
            {taskType === 'INSECT' && (
              <div>
                <div className="ui field">
                  <label>Légende</label>
                  <Radio
                    checked={isSpeciesThresholdDefault}
                    onChange={this._onIsSpeciesThresholdDefaultChanged}
                    toggle
                    label={radioLabel}
                  />
                </div>
                <Divider />
                {this.state.isSpeciesThresholdDefault && (
                  <div className="ui field inline">
                    <label>
                      Toute espèce : Seuil d'alerte quand capture supérieur à
                    </label>
                    <input type="text" value={0} disabled />
                  </div>
                )}
                {!this.state.isSpeciesThresholdDefault && (
                  <Grid>
                    {speciesThreshold.map(i => (
                      <Grid.Row>
                        <Grid.Column width={12}>
                          <div className="ui field">
                            <label>
                              {i.label} : Seuil d'alerte quand capture supérieur
                              à
                            </label>
                          </div>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <div className="ui field">
                            <input
                              type="number"
                              id={i.speciesId}
                              value={i.value}
                              onChange={this._onSpeciesCaptureChanged}
                            />
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                    ))}
                    <Grid.Row>
                      <Grid.Column width={12}>
                        <div className="ui field">
                          <label>
                            Autre espèce : Seuil d'alerte quand capture
                            supérieur à
                          </label>
                        </div>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <div className="ui field">
                          <input
                            type="number"
                            id="other_species_threshold_value"
                            value={otherSpeciesThresholdValue}
                            onChange={this._onOtherSpeciesThresholdValueChanged}
                          />
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}
              </div>
            )}
          </form>
        </div>
        <div className="actions">
          <button type="submit" form="zoneForm" className={buttonClass}>
            Enregister
          </button>
        </div>
      </Modal>
    );
  }
}

CreateZone.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, actions)(CreateZone);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/CreateZone.js